import { ReactElement, memo } from 'react';
import { yellow } from '@mui/material/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation as ErrorIcon } from '@fortawesome/free-solid-svg-icons';

import DescriptionWithIconBox from '../DescriptionWithIconBox';

import { OrderClientInfoTitleProps } from './types';

const OrderClientInfoTitle = ({
  title,
  hasError,
}: OrderClientInfoTitleProps): ReactElement => (
  <DescriptionWithIconBox
    icon={hasError ? <FontAwesomeIcon icon={ErrorIcon} /> : undefined}
    iconTooltip="Este pedido presenta errores en la carga"
    iconPosition="left"
    iconColor={yellow['800']}
    description={title}
    size={14}
  />
);

export default memo(OrderClientInfoTitle);
